module.exports = __webpack_public_path__ + "static/media/fan0_lamp0.7a641610.png";